import { useContext, useEffect, useRef } from 'react';
import ConditionalTile from '~/constants/srp/ConditionalTile';
import { useTrackEvent } from '~/context/common/AnalyticsProvider';
import InventoryContext from '~/context/srp/InventoryContext';
import { logInfo } from '~/utilities/loggers';
import {
  getNewCarVariant,
  type NewCarVariant
} from '~/utilities/srp/new-car/getNewCarVariant';

const VARIANT_MAP: Record<NewCarVariant, string> = {
  Generic: 'generic',
  Make: 'make',
  MakeModel: 'makeModel'
};

export default function useLogNewCarConfiguratorTileReceived(): void {
  const { inventory } = useContext(InventoryContext);
  const trackEvent = useTrackEvent();
  const conditionalTiles = inventory.data?.inventory?.conditionalTiles;
  const searchRequestId = inventory.data?.searchRequestId;
  const loggedId = useRef<string | null>(null);

  useEffect(() => {
    if (loggedId.current === searchRequestId) return;

    const configuratorTile = conditionalTiles?.find(
      tile => tile.key === ConditionalTile.NewCarConfigurator
    );

    if (!configuratorTile) return;

    const variant = getNewCarVariant(configuratorTile.tileMetadata);
    const context: Record<string, string | number> = {
      ...(configuratorTile.tileMetadata?.make
        ? { make: configuratorTile.tileMetadata.make }
        : {}),
      ...(configuratorTile.tileMetadata?.model
        ? { model: configuratorTile.tileMetadata.model }
        : {}),
      position: configuratorTile.position
    };

    loggedId.current = searchRequestId ?? null;
    logInfo('New Car Configurator Tile Received', {
      ...context,
      variant: VARIANT_MAP[variant]
    });
    trackEvent('New Car Configurator Tile Rendered', {
      ...context,
      variant
    });
  }, [conditionalTiles, searchRequestId, trackEvent]);
}
